import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

export const BASE_CLASS = `${PAGE_BASE_CLASS}-reportAdDrawer`

export const COMPLAINT_FORM_ID = `${BASE_CLASS}-form`
